import { WORKFLOW_IDS } from "@intelligems/ig-plugin/utils";
import type { AiChatTurn } from "@intelligems/ig-types";
import { Stack } from "@mui/material";
import { RateAi } from "@src/features/ai/components/usages/RateAi";

import { readTurnReplyMessageId } from "./turnFeedback";

interface AtlasTurnFeedbackProps {
  turn: AiChatTurn;
  streaming: boolean;
  sessionId: string;
  /** The rule the conversation is about; absent while one is being created. */
  ruleId: string | undefined;
}

/** Feedback for a finished Atlas reply, stored against its chat session and turn. */
export const AtlasTurnFeedback = ({
  turn,
  streaming,
  sessionId,
  ruleId,
}: AtlasTurnFeedbackProps) => {
  if (streaming || !sessionId) {
    return null;
  }
  const replyMessageId = readTurnReplyMessageId(turn);
  if (!replyMessageId) {
    return null;
  }

  return (
    <Stack
      alignItems="center"
      data-testid="atlas-turn-feedback"
      direction="row"
      justifyContent="flex-end"
      sx={{ mb: 2 }}
    >
      <RateAi
        sessionId={sessionId}
        feature="other"
        feedbackTarget="ai"
        workflowId={WORKFLOW_IDS.AGENTIC_LOGIC_RULE_CREATION}
        showCommentsDialog
        aiFeedbackPayload={{
          turnId: turn.turnId,
          agenticLogic: {
            subject: "chat_turn",
            ruleId,
            messageId: replyMessageId,
          },
        }}
      />
    </Stack>
  );
};
